import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Button, Result } from "antd";
import ticketsActions from "../../../redux/ticket/actions";
import { epochToNormalDate, convertToEuro } from "../../../utils/utility";
import ExpireSuccessTickets from "./ExpireSuccessTickets";
import PaymentProcessing from "./PaymentProccessing";

import { t } from "i18next";

const SuccessTicketsPayment = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 100;

  const { token, companies, companiesDetails, showEuroPrice } = useSelector(
    (state) => state.mainReducer
  );
  const { sendSuccessTicketPayment, getCreatedTickets } = ticketsActions;
  const { myPosCompanyId, myPosOrderId } = useParams();
  const { successMyPosTickets, createdTicktes } = useSelector(
    (state) => state.ticketReducer
  );

  // Функция за изпращане на заявката
  const sendPaymentRequest = () => {
    if (token.length > 0 && retryCount < MAX_RETRIES) {
      dispatch(sendSuccessTicketPayment(token, myPosCompanyId, myPosOrderId));
    }
  };

  // Повторни опити ако successMyPosTickets е празно
  useEffect(() => {
    let timer;

    if (
      token.length > 0 &&
      successMyPosTickets.length === 0 &&
      retryCount < MAX_RETRIES
    ) {
      timer = setTimeout(() => {
        setRetryCount((prevCount) => prevCount + 1);
        sendPaymentRequest();
      }, 2000);
    } else if (successMyPosTickets.length > 0 || retryCount >= MAX_RETRIES) {
      // Прекратяваме зареждането когато имаме билети или достигнем макс. брой опити
      setIsLoading(false);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successMyPosTickets, retryCount, token]);

  useEffect(() => {
    localStorage.removeItem("cart");
    localStorage.removeItem("reservedTickets");
    localStorage.removeItem("ticketExpirationTime");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const successMyPosTicketsValuesToSting = successMyPosTickets.map((ticket) =>
      ticket.toString()
    );
    if (
      token.length > 0 &&
      companies.length > 0 &&
      successMyPosTickets.length > 0
    ) {
      dispatch(
        getCreatedTickets(
          token,
          companies[0]?.id,
          successMyPosTicketsValuesToSting
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, companies, successMyPosTickets]);

  useEffect(() => {
    const savedCreatedTickets = JSON.parse(
      localStorage.getItem("createdTickets") || "[]"
    );

    const newTickets = createdTicktes.filter(
      (ticket) =>
        !savedCreatedTickets.some(
          (savedTicket) => savedTicket.ticketNumber === ticket.ticketNumber
        )
    );

    if (newTickets.length > 0) {
      const updatedTickets = [...savedCreatedTickets, ...newTickets];

      // Retain only the last 10 tickets
      const latestTickets = updatedTickets.slice(-10);

      localStorage.setItem("createdTickets", JSON.stringify(latestTickets));
    }
  }, [createdTicktes]);

  if (isLoading) {
    return <PaymentProcessing />;
  }

  return (
    <>
      {successMyPosTickets.length > 0 ? (
        <>
          <Result
            status="success"
            title={t("successfulPayment")}
            subTitle={
              <p className="success-ticket-payment-result-subtitle">
                {t("afterSuccessTicketBuy")}
              </p>
            }
            extra={[
              <a href="/" key="1">
                <Button
                  className="custom-button success-ticket-payment-result-back-button"
                  type="primary"
                >
                  {t("home")}
                </Button>
              </a>,
            ]}
            className="success-ticket-payment-result"
          />
          <div className="success-ticket-payment-result-container">
            {createdTicktes?.map((ticket) => {
              return (
                <div
                  key={ticket.ticketNumber}
                  className="success-ticket-payment-ticket-container"
                >
                  <div className="success-ticket-payment-ticket-item">
                    <img
                      alt="logo"
                      style={{ width: "100px", marginBottom: "10px" }}
                      src={`data:image/jpeg;base64,${companiesDetails?.logo}`}
                    />
                    <p style={{ color: "#b3b3b3" }}>Е-{t("ticket")}</p>
                  </div>
                  <div className="success-ticket-payment-ticket-item">
                    <span>{t("destination")}</span>
                    <span>
                      {ticket.fromName} - {ticket.toName}
                    </span>
                  </div>
                  <div className="success-ticket-payment-ticket-item">
                    <span>{t("dateAndHour")}</span>
                    <span>{epochToNormalDate(ticket.startTime)}</span>
                  </div>
                  <div className="success-ticket-payment-ticket-item">
                    <span>{t("name")}</span>
                    <span>{ticket.forPerson}</span>
                  </div>
                  <div className="success-ticket-payment-ticket-item">
                    <span>{t("email")}</span>
                    <span>{ticket.email}</span>
                  </div>
                  <div className="success-ticket-payment-ticket-item">
                    <span>{t("place")}</span>
                    <span>{ticket.place}</span>
                  </div>
                  <div className="success-ticket-payment-ticket-item">
                    <span>{t("price")}</span>
                    <div>
                      <span>
                        {ticket?.price?.toFixed(2)} €
                      </span>
                      {showEuroPrice && (
                        <>
                          <span> / </span>
                          <span>
                            {convertToEuro(ticket?.price)?.toFixed(2)} {t("lv")}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                  {/* <Button
                    type="text"
                    style={{
                      width: "100%",
                      marginTop: "20px",
                      background: "#e6e6e6",
                    }}
                    onClick={() => {
                      dispatch(
                        getTicketPDF(
                          token,
                          companies[0]?.id,
                          ticket.ticketNumber
                        )
                      );
                    }}
                    icon={<FilePdfOutlined />}
                    size="large"
                  >
                    {t("downloadTicket")}
                  </Button> */}
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <ExpireSuccessTickets />
      )}
    </>
  );
};

export default SuccessTicketsPayment;
